import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';

const AdminSupplier = () => {
  const { authFetch } = useUser();
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const users = await authFetch('/users'); // Получаем всех
        const onlySuppliers = users.filter(u => u.role === 'customer'); // Фильтруем
        setSuppliers(onlySuppliers);
      } catch (err) {
        console.error('Ошибка загрузки поставщиков:', err);
      }
    };

    fetchSuppliers();
  }, [authFetch]);

  return (
    <div className="text-white p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center text-teal-400">👥 Поставщики</h1>

      {suppliers.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-800 border border-gray-600 rounded-md shadow-md">
            <thead>
              <tr className="bg-gray-700 text-left text-sm uppercase text-gray-300">
                <th className="px-4 py-2">Имя</th>
                <th className="px-4 py-2">Логин</th>
                <th className="px-4 py-2">Telegram ID</th>
                <th className="px-4 py-2">Дата регистрации</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.map(supplier => (
                <tr key={supplier._id} className="border-t border-gray-700">
                  <td className="px-4 py-2">{supplier.firstName || '—'}</td>
                  <td className="px-4 py-2">@{supplier.username}</td>
                  <td className="px-4 py-2">{supplier.telegramId}</td>
                  <td className="px-4 py-2 text-sm text-gray-400">
                    {new Date(supplier.createdAt).toLocaleDateString('ru-RU')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-400 text-center">Поставщики не найдены.</p>
      )}
    </div>
  );
};

export default AdminSupplier;
